<template lang="html">
  <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">

    <g>
      <ellipse :style="{'fill': circleFill}" cx="255.499" cy="255.499" rx="249.283" ry="255.499"/>
    </g>

    <g transform="scale(.65) translate(130 110)">
      <path style="fill:#7ACCFF;" d="M168,305.589h176c66.274,0,120,53.726,120,120V502H48v-76.411
      C48,359.314,101.726,305.589,168,305.589z"/>
      <polygon style="fill:#FFFFFF;" points="163.579,305.589 256,465.667 348.421,305.589 "/>
      <g>
      <path style="fill:#FFCDAC;" d="M298,270.011v26.244c0,23.196-18.804,42-42,42l0,0c-23.196,0-42-18.804-42-42v-26.244"/>
      <path style="fill:#FFCDAC;" d="M348,113.301v70.905c0,50.81-41.19,92-92,92l0,0c-50.81,0-92-41.19-92-92v-70.905
      C164,113.301,348,113.301,348,113.301z"/>
      </g>
      <path style="fill:#5CC1FF;" d="M212.833,10h143.504v61.883c0,32.097-26.02,58.117-58.117,58.117H192.833
      C170.834,130,153,112.166,153,90.167V69.833C153,36.788,179.788,10,212.833,10z"/>
      <path d="M350.066,295.735c-0.849-0.141-1.704-0.174-2.548-0.097c-1.169-0.031-39.518-0.049-39.518-0.049v-23.667
      c29.912-17.8,50-50.454,50-87.716v-79.7c5.312-9.694,8.338-20.811,8.338-32.623V10c0-5.522-4.477-10-10-10H212.833
      C174.327,0,143,31.327,143,69.833v20.334c0,11.793,4.126,22.636,11,31.179v62.86c0,37.262,20.088,69.916,50,87.716v23.667
      c0,0-38.344,0.018-39.51,0.049c-0.848-0.078-1.708-0.045-2.561,0.098C93.054,298.918,38,355.942,38,425.589V502
      c0,5.522,4.477,10,10,10h416c5.523,0,10-4.478,10-10v-76.411C474,355.94,418.942,298.915,350.066,295.735z M256,348.256
      c21.842,0,40.569-13.543,48.258-32.667h26.843L256,445.667l-75.101-130.078h26.843C215.431,334.713,234.158,348.256,256,348.256z
      M163,69.833C163,42.355,185.355,20,212.833,20h133.504v20H270.5c-5.523,0-10,4.478-10,10s4.477,10,10,10h75.838v11.883
      c0,26.532-21.585,48.117-48.117,48.117H192.833C176.383,120,163,106.617,163,90.167V69.833z M174,184.206v-47.913
      c5.814,2.383,12.171,3.707,18.833,3.707H298.22c14.841,0,28.578-4.785,39.779-12.874v57.08c0,45.215-36.785,82-82,82
      S174,229.421,174,184.206z M256,286.206c11.174,0,21.931-1.812,32-5.147v15.197c0,17.645-14.355,32-32,32s-32-14.355-32-32v-15.197
      C234.069,284.394,244.826,286.206,256,286.206z M454,492h-36v-48c0-5.522-4.477-10-10-10s-10,4.478-10,10v48H114v-79.818
      c0-5.522-4.477-10-10-10s-10,4.478-10,10V492H58v-66.411c0-57.306,44.051-104.509,100.067-109.547l89.272,154.625
      c1.786,3.094,5.087,5,8.66,5c3.573,0,6.874-1.906,8.66-5l89.272-154.625C409.949,321.08,454,368.283,454,425.589V492z"/>
      <path d="M222.21,171.63c-2.63,0-5.21,1.07-7.07,2.93c-1.86,1.86-2.93,4.44-2.93,7.07s1.07,5.21,2.93,7.07
      c1.86,1.859,4.44,2.93,7.07,2.93s5.21-1.07,7.07-2.93c1.86-1.86,2.93-4.44,2.93-7.07s-1.07-5.21-2.93-7.07
      C227.42,172.7,224.84,171.63,222.21,171.63z"/>
      <path d="M290.06,191.63c2.64,0,5.21-1.07,7.07-2.93c1.87-1.86,2.93-4.44,2.93-7.07s-1.06-5.21-2.93-7.07
      c-1.86-1.859-4.43-2.93-7.07-2.93c-2.63,0-5.21,1.07-7.07,2.93c-1.86,1.86-2.93,4.44-2.93,7.07s1.07,5.21,2.93,7.07
      C284.86,190.56,287.43,191.63,290.06,191.63z"/>
      <path d="M231.75,60c2.63,0,5.21-1.07,7.07-2.931c1.86-1.859,2.93-4.439,2.93-7.069s-1.07-5.21-2.93-7.07S234.38,40,231.75,40
      s-5.21,1.069-7.07,2.93c-1.86,1.86-2.93,4.44-2.93,7.07s1.07,5.21,2.93,7.069C226.54,58.93,229.12,60,231.75,60z"/>
      <path d="M271.28,214.164c-3.905-3.904-10.237-3.904-14.143,0c-0.89,0.89-1.928,1.022-2.468,1.022s-1.579-0.133-2.468-1.022
      c-3.905-3.904-10.237-3.904-14.143,0c-3.905,3.905-3.905,10.237,0,14.143c4.58,4.579,10.595,6.869,16.611,6.869
      s12.031-2.29,16.611-6.869C275.185,224.401,275.185,218.069,271.28,214.164z"/>
      <path d="M408,396.18c-2.63,0-5.21,1.07-7.07,2.93c-1.86,1.86-2.93,4.44-2.93,7.07s1.07,5.21,2.93,7.07
      c1.86,1.859,4.44,2.93,7.07,2.93s5.21-1.07,7.07-2.93c1.86-1.86,2.93-4.44,2.93-7.07s-1.07-5.21-2.93-7.07
      C413.21,397.25,410.63,396.18,408,396.18z"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'Event',
  props: {
    circleFill: {
      default: '#bdcdda'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/icons/menu/Occupation.vue